import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { getSectionLabel } from 'ion-sections'
import { withRouter } from 'react-router'
import { fetchAuthor } from '../../store/author'
import { bindActionCreators } from 'redux'
import { Articles, SectionMeta } from 'ion-article-cmp'
import Ad from '../components/Ad'
import WingBanners from '../components/WingBanners'
import FORMATS from '../components/AdFormats'
import Sidebar from '../components/Sidebar'
import logo from '../static/general/house-and-garden.svg'
import NoImage from '../static/no-image.png'
import NotFound from './NotFound'
import { DesktopTablet, MobileElse } from 'ion-media'
import MagazineCover from '../components/MagazineCover'
import AuthorBio from '../components/AuthorBio'

class AuthorSectionPage extends (React.Component) {
  constructor (props) {
    super(props)
    props.fetchAuthor(props.authorSlug)
  }

  render () {
    const props = this.props
    return (
      <>
        <Helmet titleTemplate='%s' title={props.title || getSectionLabel(props.section)}>
          <meta property='fb:app_id' content='293175074032541' />
          <meta property='og:type' content='section' />
          <meta property='og:title' content={props.title || getSectionLabel(props.section)} />
          <meta property='og:image' content={logo} />
          <meta itemProp='headline' content={props.title || 'Latest News from ' + getSectionLabel(props.section)} />
          <meta name='description' content={props.description} />
          <meta itemProp='description' content={props.description} />
          <meta property='og:description' content={props.description} />
          <meta property='og:url' content={props.url} />
          <meta property='keywords' content={props.keywords} />
          <meta name='twitter:site' content={props.twitterName} />
          <meta name='twitter:creator' content={props.twitterName} />
          <meta name='twitter:title' content={props.title || getSectionLabel(props.section)} />
          <meta name='twitter:description' content={props.description} />
          <meta itemprop='image' content={logo} />
          <meta itemprop='thumbnailUrl' content={logo} />
          <meta name='twitter:card' content='summary_large_image' />
          <meta name='twitter:image:src' content={logo} />
        </Helmet>
        <WingBanners useSmall={props.useSmall} isConnected={props.isConnected} location={props.location} onSlotRenderEndedLeft={props.onSlotRenderEndedLeft} onSlotRenderEndedRight={props.onSlotRenderEndedRight} />
        <Ad isConnected={props.isConnected} path={`/${process.env.RAZZLE_DFP_CODE}/${props.section}`} slotId='leaderboard-1' targeting={{ leaderboard: '1' }} collapseEmptyDiv className='advert-leaderboard-1' {...FORMATS.leaderboard} />
        <div className='wrapper article-listing'>
          <div className='author article-list'>
            {props.author && props.author.author &&
              <AuthorBio {...props.author.author} noImage={NoImage} />}
            <Articles {...props} component={props.template} section={props.section} count={24} pageSize={24} noImage={NoImage} notFound={NotFound} withMore />
          </div>
          <Sidebar section={props.section}>
            <DesktopTablet>
              <MagazineCover />
            </DesktopTablet>
          </Sidebar>
        </div>
        <MobileElse>
          <Ad isConnected={props.isConnected} path={`/${process.env.RAZZLE_DFP_CODE}/${props.section}`} slotId='leaderboard-3' targeting={{ leaderboard: '3' }} collapseEmptyDiv className='advert-leaderboard-3' {...FORMATS.leaderboard} />
        </MobileElse>
        <SectionMeta {...props} />
      </>
    )
  }
}

AuthorSectionPage.defaultProps = {
  component: 'AuthorArticles',
  section: 'author'
}

const mapDispatchToProps = (dispatch) => bindActionCreators({ fetchAuthor }, dispatch)

export default withRouter(connect((state) => ({ articles: state.articles, author: state.author }), mapDispatchToProps)(AuthorSectionPage))
